import * as React from 'react';
import { I18nextProvider } from 'react-i18next';
import chunk from 'lodash/chunk';
import {
  ExperimentsProvider,
  withExperiments,
} from '@wix/wix-experiments-react';
import { ChallengeCard } from '../ChallengeCard';

import i18n from '../../config/i18n';
import styles from './Widget.st.css';
import { ExperimentsBag } from '@wix/wix-experiments';
import {
  TextAlignment,
  ImageShape,
  ImageRatio,
  CropSelection,
} from '../Settings/challengeSettings/challengeSettings.types';
import { VIEW_MODE } from '../../config/constants';
import { EmptyList } from '../EmptyList';

export interface IWidgetRootProps {
  startTimeOfRender: number;
  onRender(delta: number, itemsCount: number): void;
  renderingEnv: 'backend' | 'browser';
  viewMode: VIEW_MODE;
  language: string;
  translations?: object;
  experiments: ExperimentsBag;
  host?: any;
  items?: any;
  userPaidPlans: any;
  toLink(): void;
  itemsPerRow?: number;
  displayParams?: {
    image: boolean;
    duration: boolean;
    participants: boolean;
    divider: boolean;
    price: boolean;
  };
  textAlignment?: TextAlignment;
  cardSpacing?: number;
  imageShape?: ImageShape;
  imageRatio?: ImageRatio;
  cropSelection: CropSelection;
  buttonState: 'default' | 'hover';
}

export default class WidgetRoot extends React.Component<IWidgetRootProps> {
  static displayName = 'ChallengeList';

  componentDidMount() {
    this.sendBi();
  }

  componentDidUpdate(prevProps) {
    if (
      (prevProps.renderingEnv === 'backend' || !prevProps.renderingEnv) &&
      this.props.renderingEnv === 'browser'
    ) {
      this.sendBi();
    }
  }

  sendBi() {
    const { startTimeOfRender, onRender, items } = this.props;
    const now = new Date().getTime();
    const delta = startTimeOfRender ? now - startTimeOfRender : 0;

    onRender && onRender(delta, (items && items.length) || 0);
  }

  render() {
    const {
      language,
      viewMode,
      experiments,
      items,
      userPaidPlans,
      toLink,
      itemsPerRow,
      displayParams,
      textAlignment,
      cardSpacing,
      imageShape,
      imageRatio,
      cropSelection,
      translations,
      host,
      buttonState,
    } = this.props;

    return (
      <I18nextProvider i18n={i18n({ language, translations })}>
        <ExperimentsProvider options={{ experiments }}>
          {!items || !items.length ? (
            <EmptyList />
          ) : (
            <Widget
              items={items}
              userPaidPlans={userPaidPlans}
              toLink={toLink}
              host={host}
              itemsPerRow={itemsPerRow}
              displayParams={displayParams}
              textAlignment={textAlignment}
              cardSpacing={cardSpacing}
              imageShape={imageShape}
              imageRatio={imageRatio}
              cropSelection={cropSelection}
              language={language}
              viewMode={viewMode}
              formFactor={host.formFactor}
              buttonState={buttonState}
            />
          )}
        </ExperimentsProvider>
      </I18nextProvider>
    );
  }
}

export const Widget = withExperiments<any>(
  ({
    host,
    items,
    userPaidPlans,
    t,
    toLink,
    itemsPerRow,
    displayParams,
    textAlignment,
    cardSpacing,
    imageShape,
    imageRatio,
    cropSelection,
    language,
    viewMode,
    formFactor,
    buttonState,
    ...rest
  }) => {
    const isMobile = formFactor === 'Mobile';
    const rows = chunk(items, itemsPerRow);

    return (
      <div
        data-hook="challenge-list-wrapper"
        {...styles('root', { mobile: isMobile }, rest)}
      >
        {rows.map((row, i) => (
          <ul
            key={`challenges-list-${i}`}
            data-hook="challenge-list"
            className={styles.wrapper}
            style={{
              justifyContent:
                itemsPerRow === 1 || items.length === 1 ? `center` : null,
              margin: `20px ${20 - cardSpacing / 2}px 0`,
              ...(isMobile && {
                margin: `20px 0 0`,
              }),

              //gridGap: `${cardSpacing}px`,
              // gridTemplateColumns: `repeat(${
              //   isMobile ? 1 : itemsPerRow
              // }, minmax(240px, 616px))`,
              // gridTemplateColumns: `repeat(${
              //   isMobile ? 1 : 'auto-fill' //itemsPerRow
              // }, minmax(240px, 1fr))`,
            }}
          >
            {row.map((item, index) => (
              <li
                className={styles.wrapperItem}
                key={index}
                style={{
                  margin: `0 ${cardSpacing / 2}px ${cardSpacing}px`,
                  width: `calc(${100 / itemsPerRow}% - ${cardSpacing}px)`,
                  ...(isMobile && {
                    width: `calc(100% - 40px)`,
                  }),
                }}
              >
                <ChallengeCard
                  challenge={item}
                  userPaidPlans={userPaidPlans}
                  displayParams={displayParams}
                  goTo={toLink}
                  textAlignment={textAlignment}
                  imageShape={imageShape}
                  imageRatio={imageRatio}
                  cropSelection={cropSelection}
                  locale={language}
                  isMobile={isMobile}
                  buttonState={buttonState}
                />
              </li>
            ))}
          </ul>
        ))}
      </div>
    );
  },
);
